import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = sessionStorage.getItem("fto_admin_token") || localStorage.getItem("fto_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("fto_token");
      sessionStorage.removeItem("fto_admin_token");
      setUser(false);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("fto_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("fto_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("fto_token");
    sessionStorage.removeItem("fto_admin_token");
    setUser(false);
  };

  const adminUnlock = async (code) => {
    const { data } = await api.post("/admin/unlock", { code });
    sessionStorage.setItem("fto_admin_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const adminLock = () => {
    sessionStorage.removeItem("fto_admin_token");
    // fall back to any regular user session
    refresh();
  };

  const adminUnlocked = !!sessionStorage.getItem("fto_admin_token");

  const isGuest = user === false;
  const isPremium = !!(user && (user.is_premium || user.role === "admin"));
  const isAdmin = !!(user && user.role === "admin");

  return (
    <AuthContext.Provider
      value={{ user, loading, login, register, logout, refresh, setUser, adminUnlock, adminLock, adminUnlocked, isGuest, isPremium, isAdmin }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
